import { createFileRoute, redirect } from '@tanstack/react-router';
import { ContestDetailPage } from '../pages/contests/contest-detail-page';
import { isAuthenticated } from '../auth/session';

export const Route = createFileRoute('/contests/$id/')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' });
    }
  },
  component: function ContestDetailRoute() {
    const { id } = Route.useParams();
    return <ContestDetailPage contestId={id} />;
  },
});
